module.exports = __webpack_public_path__ + "static/media/07.a7511368.mp3";